import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Partner.css";
import "../../../styles/motion.css";

export default function Partner() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const images = containerRef.current.querySelectorAll("img");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).classList.add("motion-blur-in");
            (entry.target as HTMLElement).style.opacity = "1";
          } else {
            (entry.target as HTMLElement).classList.remove("motion-blur-in");
            (entry.target as HTMLElement).style.opacity = "0";
          }
        });
      },
      { threshold: 0.1 },
    );

    images.forEach((img) => observer.observe(img));

    return () => observer.disconnect();
  }, []);

  const { t } = useTranslation();

  return (
    <section className="partner-section">
      <h2 className="partner-titulo text-shine">{t("partner.title")}</h2>

      <div className="partner-imagenes" ref={containerRef}>
        <img
          src="/Oracle-Logo.webp"
          alt="Oracle Partner"
          className="motion-hover-scale"
          style={{ opacity: 0, transition: "opacity 0.2s" } as React.CSSProperties}
        />

        <img
          src="/Google-Logo.webp"
          alt="Google Partner"
          className="motion-hover-scale"
          style={{
            opacity: 0,
            transition: "opacity 0.2s",
            animationDelay: "600ms",
          } as React.CSSProperties}
        />
      </div>
    </section>
  );
}
